// extracted by mini-css-extract-plugin
module.exports = {"layout":"TopHeader_layout_39oW5","logo":"TopHeader_logo_3baMy","slogan":"TopHeader_slogan_ml2-5"};